import { useTranslation } from "react-i18next";

import { ReviewVisitTableHeaderCell } from "~/modules/project/screens/ProjectReviewVisitV2Screen/components/ReviewVisitTable";

export function TimeReportsTableHeader() {
    const { t } = useTranslation("project");

    return (
        <>
            <ReviewVisitTableHeaderCell>
                {t("projectReviewVisitV2.timeReportsRoute.table.fieldworker")}
            </ReviewVisitTableHeaderCell>
            <ReviewVisitTableHeaderCell>
                {t("projectReviewVisitV2.timeReportsRoute.table.start")}
            </ReviewVisitTableHeaderCell>
            <ReviewVisitTableHeaderCell>
                {t("projectReviewVisitV2.timeReportsRoute.table.end")}
            </ReviewVisitTableHeaderCell>
            <ReviewVisitTableHeaderCell sx={{ gridColumn: "-3/-1" }}>
                {t("projectReviewVisitV2.timeReportsRoute.table.duration")}
            </ReviewVisitTableHeaderCell>
        </>
    );
}
